// WKWebView fetch binding fix — supabase-js calls `this.fetch()` internally
// which detaches from window context. Rebind globally.
const _origFetch = window.fetch.bind(window)
;(window as any).fetch = _origFetch
;(globalThis as any).fetch = _origFetch

import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import './style.css'

createApp(App).use(router).mount('#app')
